export const PricingTierEditTitle = () => {
  return <span>Edit pricing tier</span>;
};

export const PricingTierCreateTitle = () => {
  return <span>Create new pricing tier</span>;
};
